import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift, Check } from 'lucide-react';
const bonuses = [{
  id: 'B1',
  title: 'Guía de Hábitos Poderosos',
  desc: 'Cómo crear hábitos saludables que duren.',
  image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?w=400&q=70&auto=format&fit=crop',
  alt: 'Cuaderno de hábitos diarios'
}, {
  id: 'B2',
  title: 'Planificador de Rutinas',
  desc: 'Organiza entrenamientos y mide tu progreso.',
  image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=400&q=70&auto=format&fit=crop',
  alt: 'Planificador semanal de rutinas'
}, {
  id: 'B3',
  title: 'Mini Guía de Motivación Mental',
  desc: 'Técnicas para mantenerte enfocado.',
  image: 'https://images.unsplash.com/photo-1545389336-cf090694435e?w=400&q=70&auto=format&fit=crop',
  alt: 'Persona enfocada y meditando'
}];
export function Bonuses() {
  return <section className="py-10 md:py-16 px-4 bg-brand-950/30 border-y border-brand-900/30" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <div className="text-center mb-6 md:mb-10" data-id="element-18">
          <div className="inline-flex items-center gap-1.5 bg-brand-500/20 text-brand-400 border border-brand-500/30 px-3 py-1 rounded-full text-[10px] md:text-sm font-bold mb-2 md:mb-3 tracking-wider" data-id="element-19">
            <Gift className="w-3 h-3 md:w-4 md:h-4" data-id="element-20" /> INCLUIDOS GRATIS
          </div>
          <h2 className="text-3xl md:text-5xl font-bebas text-white" data-id="element-21">
            3 BONUS EXCLUSIVOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4 mb-5 md:mb-8" data-id="element-22">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} whileTap={{
          scale: 0.98
        }} whileHover={{
          y: -3
        }} className="bg-zinc-900/80 border border-brand-500/20 rounded-xl overflow-hidden flex flex-row md:flex-col items-stretch hover:border-brand-500/50 transition-colors" data-id="element-23">
              <div className="relative w-24 h-24 md:w-full md:h-32 shrink-0 overflow-hidden bg-zinc-800" data-id="element-24">
                <img src={bonus.image} alt={bonus.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-25" />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-900/90 via-zinc-900/20 to-transparent" data-id="element-26" />
                <div className="absolute top-1.5 left-1.5 bg-brand-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded flex items-center gap-1" data-id="element-27">
                  <Gift className="w-2.5 h-2.5" data-id="element-28" /> {bonus.id}
                </div>
              </div>

              <div className="p-3 md:p-4 flex-1 flex flex-col justify-center" data-id="element-29">
                <h3 className="text-sm md:text-base font-bold text-white mb-0.5 md:mb-1.5 leading-tight" data-id="element-30">
                  {bonus.title}
                </h3>
                <p className="text-zinc-400 text-[11px] md:text-sm leading-snug mb-1.5" data-id="element-31">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-1 text-[10px] md:text-xs text-brand-400 font-semibold" data-id="element-32">
                  <Check className="w-3 h-3" data-id="element-33" /> Incluido gratis
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-500 text-white p-3 md:p-5 rounded-xl text-center shadow-[0_0_30px_rgba(249,115,22,0.25)]" data-id="element-34">
          <h3 className="text-base md:text-2xl font-bebas tracking-wide" data-id="element-35">
            VALOR TOTAL: $25.000 —{' '}
            <span className="text-yellow-300" data-id="element-36">HOY GRATIS</span>
          </h3>
        </motion.div>
      </div>
    </section>;
}